const styles = theme => {
    return {
        root: {
            marginTop: theme.root.marginTop,
            paddingBottom: theme.root.paddingBottom,
            background: theme.bodyBackground ? theme.bodyBackground : '#f9f9f9',
            minHeight: '100vh',
            fontFamily: theme.fontFamily + '!important'
        },
        rootCenter: {
            ...(!theme.isMobile && {
                display: 'flex'
            })
        },
        container: {
            maxWidth: 960,
            margin: 'auto',
            ...(!theme.isMobile && {
                paddingLeft: 16,
                paddingRight: 16
            })
        },
        containerCenter: {
            width: theme.containerWidthCenter,
            maxWidth: '100%',
            margin: '0px auto 0 auto',
            ...(!theme.isMobile && {
                margin: '40px auto 0 auto'
            })
        },
        appBar: {
            position: 'relative'
        },
        layout: {
            width: 'auto',
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            ...(!theme.isMobile && {
                width: 600,
                marginLeft: 'auto',
                marginRight: 'auto'
            })
        },
        wrapper: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            background: theme.paper ? theme.paper.background : '#f9f9f9',
            minHeight: theme.xsHeight ? theme.xsHeight : '80vh',
            ...(!theme.isMobile && {
                minHeight: theme.height ? theme.height : '750px'
            }),
            fontFamily: theme.fontFamily + '!important'
        },
        paper: {
            overflow: 'hidden',
            padding: theme.spacing(2),
            paddingBottom: theme.spacing(1) + 'px!important',
            borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
            ...(!theme.isMobile && {
                padding: theme.spacing(4),
                paddingTop: theme.spacing(4) + 'px!important',
                paddingBottom: theme.spacing(1) + 'px!important',
                borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important'
            }),
            boxShadow: theme.paper ? theme.paper.boxShadow : null,
            marginBottom: theme.paper ? theme.paper.marginBottom : theme.spacing(3),
            paddingTop: theme.paper ? theme.paper.paddingTop : theme.spacing(3) + 'px!important'
        },
        simpleWrapper: {},
        stepperContainer: {
            maxWidth: '570px',
            padding: 0,
            margin: '0px auto',
            ...(!theme.isMobile && {
                padding: '0 16px'
            })
        },
        fullScreenPaper: {
            position: 'absolute',
            top: 60
        },
        loader: {
            position: 'absolute',
            top: '-5px',
            width: '100%',
            left: '0',
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            zIndex: 10,
            height: 5
        },
        stepper: {
            padding: `0 0 ${theme.spacing(3)}px`
        },
        buttons: {
            display: 'block',
            //justifyContent: 'flex-end',
            paddingTop: theme.spacing(4),
            background: theme.pagination ? theme.pagination.background : 'transparent',
            position: theme.pagination ? theme.pagination.position : 'inherit',
            padding: theme.pagination ? theme.pagination.padding : null,
            bottom: theme.pagination ? theme.pagination.bottom : null,
            width: theme.pagination ? theme.pagination.width : null
        },
        button: {
            marginTop: theme.spacing(3),
            marginLeft: theme.spacing(1)
        },
        bottomNavigation: {
            width: '100%',
            position: 'fixed',
            bottom: 0,
            zIndex: 1,
            borderTop: '1px solid #cccccc;'
        },
        fullscreenToggle: {
            top: '-10px',
            left: '50%',
            zIndex: '20',
            position: 'absolute',
            marginLeft: '-10px',
            boxShadow: '0 0px 5px rgba(0, 0, 0, 0.25)',
            background: '#f9f9f9',
            width: '20px',
            height: '20px',
            minHeight: '20px'
        },
        backButton: {
            display: 'block',
            margin: 'auto',
            color: theme.backButton ? theme.backButton.color : 'rgba(0, 0, 0, 0.5)',
            marginTop: theme.backButton ? theme.backButton.marginTop : 7,
            marginBottom: theme.backButton ? theme.backButton.marginBottom : 30,
            width: theme.backButton ? theme.backButton.width : null,
            maxWidth: theme.backButton ? theme.backButton.maxWidth : null,
            borderRadius: theme.borderRadius ? theme.backButton.borderRadius : 10,
            textTransform: 'none'
        },
        twoButtonsBackButton: {
            //marginLeft: theme.spacing.unit * 2,
            ...(!theme.isMobile &&
                {
                    //marginLeft: theme.spacing.unit * 4,
                })
        },
        forwardButton: {
            display: 'block',
            margin: 'auto',
            //marginRight: theme.spacing.unit * 2,
            ...(!theme.isMobile &&
                {
                    //marginRight: theme.spacing.unit * 4,
                }),
            padding: '8px 28px',
            boxShadow: theme.forwardButton ? theme.forwardButton.boxShadow : null,
            color: theme.forwardButton ? theme.forwardButton.color : null,
            borderRadius: theme.borderRadius ? theme.borderRadius : 20,
            width: theme.forwardButton ? theme.forwardButton.width : null,
            maxWidth: theme.forwardButton ? theme.forwardButton.maxWidth : null,
            background: theme.forwardButton ? theme.forwardButton.background : null,
            marginTop: theme.forwardButton ? theme.forwardButton.marginTop : 0,
            marginBottom: theme.forwardButton ? theme.forwardButton.marginBottom : theme.spacing(2)
        },
        rightIcon: {
            marginLeft: theme.spacing(1),
            marginRight: -theme.spacing(1) * 0.5
        },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 8px',
            ...theme.mixins.toolbar,
            justifyContent: 'center',
            textAlign: 'center',
            marginBottom: -20
        },
        logoText: {
            fontSize: '26px',
            marginLeft: '8px',
            textTransform: 'uppercase'
        },
        hideOnMobile: {
            ...(theme.isMobile && {
                display: 'none'
            })
        },
        infoCardWrapper: {
            paddingLeft: theme.spacing(4)
        },
        loadingSpinner: {
            color: theme.palette.primaryColor,
            margin: '100px auto'
        },
        loaderWrapper: {
            marginBottom: 50,
            display: 'flex',
            flexGrow: 1
        }
    }
}

export { styles }
